import { createStore } from "vuex";
import axiosClient from "axios";
import {
  getActiveDatabase,
  setActiveDatabase,
  clearActiveDatabase,
  DEFAULT_DATABASE,
  DB_MAPPING,
  isLiveCasinoActive,
  getComputedDatabase,
} from "../helpers/databaseMapping";

const store = createStore({
  state() {
    return {
      endpoint: process.env.VUE_APP_APIENDPOINT,
      selectedDatabase: getActiveDatabase(),
      isMenuOpen: false,
      isUtilitiesMenuOpen: false,
      gameIdTheEar: {
        augustusburger: "Augustus Burger",
        candydreams: "Candy Dreams",
        deeptreasure: "Deep Treasure",
        dragonstale: "Dragons'Tale",
        egyptianbook: "Egyptian Book",
        fruityhills: "Fruity Hills",
        goldenpot: "Golden Pot",
        jokearparty: "Joker Party",
        jungleglade: "Jungle Glade",
        revolverduels: "Revolver Duels",
        riosambaspin: "Rio Samba Spin",
        slotbar90: "Slot Bar 90'",
        straighttojail: "Straight To Jail",
        tigerblessing: "Tiger Blessing",
        vampirecastle: "Vampire Castle",
        zeuswrath: "Zeus' Wrath",
        plinkoear: "Plinko",
      },
      plinkoGamesList: ["plinkoear"],
      crashGamesList: [
        "augustus",
        "earplane",
        "vegasair",
        "spicyburger",
        "earplaneita",
      ],
      crashGameOptions: {
        all: "All",
        cashout_1: "Cashout 1",
        cashout_2: "Cashout 2",
        oddeven: "Odd/Even",
        ranges: "Ranges",
        cashout_1_cashout_2: "Cashout 1 + Cashout 2",
        cashout_1_oddeven: "Cashout 1 + Odd/Even",
        cashout_1_ranges: "Cashout 1 + Ranges",
        cashout_2_oddeven: "Cashout 2 + Odd/Even",
        cashout_2_ranges: "Cashout 2 + Ranges",
        oddeven_ranges: "Odd/Even + Ranges",
        cashout_1_cashout_2_oddeven: "Cashout 1 + Cashout 2 + Odd/Even",
        cashout_1_cashout_2_ranges: "Cashout 1 + Cashout 2 + Ranges",
        cashout_1_oddeven_ranges: "Cashout 1 + Odd/Even + Ranges",
        cashout_2_oddeven_ranges: "Cashout 2 + Odd/Even + Ranges",
      },
      crashMultiplierGameOptions: {
        cashout_1_cashout_2: "Cashout 1 + Cashout 2",
        cashout_1: "Cashout 1",
        cashout_2: "Cashout 2",
      },
      plinkoGameOptions: {
        all: "All",
        low: "Low",
        medium: "Medium",
        high: "High",
        low_medium: "Low + Medium",
        low_high: "Low + High",
        medium_high: "Medium + High",
      },
      gameChoose: null,
      isLoadingSearch: false,
      typeOfViewMultipliersPage: "table",
      allowedSkins: [],
      allowedGamesFreebet: [],
      isAdmin: 0,
      user_id: 0,
      livePlayerModalOpen: false,
      livePlayersToShowModal: 0,
      chatSkinFilter: 0,
      globlaSearchOpen: false,
      skinStorage: null,
      multipleMultipliersGames: ["boostrace"],
    };
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    setGameChoose(state, payload) {
      state.gameChoose = payload;
    },
    decrement(state) {
      state.count--;
    },
    setLivePlayerModalOpen(state, value) {
      state.livePlayerModalOpen = value;
    },
    setLivePlayersToShowModal(state, value) {
      state.livePlayersToShowModal = value;
    },
    setIsMenuOpen(state, value) {
      state.isMenuOpen = value;
    },
    setIsUtilitiesMenuOpen(state, value) {
      state.isUtilitiesMenuOpen = value;
    },
    SET_SELECTED_DATABASE(state, dbName) {
      const newDb = dbName || DEFAULT_DATABASE;
      state.selectedDatabase = newDb;
      setActiveDatabase(newDb);
    },
    SET_LIVE_CASINO_FILTER(state, game = "livecasino") {
      const target = DB_MAPPING[game?.toString().toUpperCase()] || game || DB_MAPPING.LIVECASINO;
      state.selectedDatabase = target;
      setActiveDatabase(target);
    },
    CLEAR_LIVE_CASINO_FILTER(state) {
      state.selectedDatabase = DEFAULT_DATABASE;
      clearActiveDatabase();
    },
    setTypeOfViewMultipliersPage(state, value) {
      state.typeOfViewMultipliersPage = value;
    },
    setAllowedSkins(state, value) {
      state.allowedSkins = value;
    },
    setIsAdmin(state, value) {
      state.isAdmin = value;
    },
    setUserId(state, value) {
      state.user_id = value;
    },
    setSkinID(state, value) {
      state.skinStorage = value;
      // console.log("STATE STORE SKIN", state.skinStorage);
    },
    setChatSkinFilt(state, value) {
      state.chatSkinFilter = value;
    },
    setGlobalSearchOpen(state, value) {
      state.globlaSearchOpen = value;
    },
  },

  actions: {
    incrementAsync({ commit }) {
      setTimeout(() => {
        commit("increment");
      }, 1000);
    },

    rangeColorHighlight(val) {
      let parsedVal = parseFloat(val);
      if (parsedVal < 1.41) {
        return "low-val";
      } else if (parsedVal > 1.4 && parsedVal < 2.81) {
        return "mid-val";
      } else {
        return "high-val";
      }
    },
    async performSearch({ state }, { endpoint, params }) {
      state.isLoadingSearch = true;

      try {
        const db = getComputedDatabase(state.selectedDatabase);
        const base = state.endpoint || process.env.VUE_APP_APIENDPOINT || "";
        const cleanBase = base.endsWith("/") ? base : `${base}/`;
        const cleanEndpoint = (endpoint || "").startsWith("/")
          ? (endpoint || "").slice(1)
          : endpoint || "";
        const url = `${cleanBase}${db}/${cleanEndpoint}`.replace(
          /([^:]\/)\/+/g,
          "$1"
        );

        const response = await axiosClient.get(url, { params });
        state.isLoadingSearch = false;

        return response;
      } catch (error) {
        state.isLoadingSearch = false;
        console.error("Errore durante la ricerca:", error);
        throw error;
      }
    },
    async getGame({ state, commit }, { endpoint, params }) {
      let gameChoose = null;
      if (state.selectedDatabase === "theearcasino") {
        gameChoose = state.gameIdTheEar;
      }
      commit("setGameChoose", gameChoose);
    },
    toggleLiveCasinoFilter({ commit, state }, game = "livecasino") {
      const target = DB_MAPPING[game?.toString().toUpperCase()] || game || DB_MAPPING.LIVECASINO;
      if (state.selectedDatabase === target) {
        commit("CLEAR_LIVE_CASINO_FILTER");
        return DEFAULT_DATABASE;
      } else {
        commit("SET_LIVE_CASINO_FILTER", target);
        return target;
      }
    },
  },

  getters: {
    selectedDatabase(state) {
      return state.selectedDatabase || getActiveDatabase();
    },
    isLiveCasinoActive(state) {
      return (state.selectedDatabase || getActiveDatabase()) === DB_MAPPING.LIVECASINO;
    },
    isMenuOpen(state) {
      return state.isMenuOpen;
    },
    isUtilitiesMenuOpen(state) {
      return state.isUtilitiesMenuOpen;
    },
    endpoint(state) {
      return `${state.endpoint}/${state.selectedDatabase || getActiveDatabase()}`;
    },
    isLoadingSearch(state) {
      return state.isLoadingSearch;
    },
    typeOfViewMultipliersPage(state) {
      return state.typeOfViewMultipliersPage;
    },
    allowedSkins(state) {
      return state.allowedSkins;
    },
    allowedGames(state) {
      return state.allowedGames;
    },
    allowedGamesFreebet(state) {
      return state.gameChoose;
    },
    isAdmin(state) {
      return state.isAdmin;
    },
    user_id(state) {
      return state.user_id;
    },
    livePlayerModalOpen(state) {
      return state.livePlayerModalOpen;
    },
    livePlayersToShowModal(state) {
      return state.livePlayersToShowModal;
    },
    chatSkinFilter(state) {
      return state.chatSkinFilter;
    },
    globlaSearchOpen(state) {
      return state.globlaSearchOpen;
    },
    skinStorage(state) {
      return state.skinStorage;
    },
    crashGameOptions(state) {
      return state.crashGameOptions;
    },
    crashMultiplierGameOptions(state) {
      return state.crashMultiplierGameOptions;
    },
    plinkoGameOptions(state) {
      return state.plinkoGameOptions;
    },
    crashGamesList(state) {
      return state.crashGamesList;
    },
    plinkoGamesList(state) {
      return state.plinkoGamesList;
    },
    gameIdTheEar(state) {
      return state.gameIdTheEar;
    },
    multipleMultipliersGames(state) {
      return state.multipleMultipliersGames;
    },
    getTypeID: (state) => (type_id) => {
      const activeDatabase = state.selectedDatabase;

      const isMultiple =
        state.multipleMultipliersGames?.includes(activeDatabase);

      if (isMultiple) {
        switch (type_id) {
          case "All":
            return "";
          case "Cashout 1":
            return 1;
          case "Cashout 2":
            return 2;
          case "Cashout 3":
            return 3;
          default:
            return 4;
        }
      } else {
        switch (type_id) {
          case "All":
            return "";
          case "Cashout 1":
            return 1;
          case "Cashout 2":
            return 2;
          case "Even/Odd":
            return 3;
          default:
            return 4;
        }
      }
    },
    getTypeIDFromRow: (state) => (row) => {
      let typeID = parseInt(row.type_id);
      const activeDatabase = state.selectedDatabase;

      const isMultiple =
        state.multipleMultipliersGames?.includes(activeDatabase);

      if (!isMultiple) {
        return typeID == 1 || typeID == 2
          ? `Cashout ${typeID}`
          : typeID == 3
            ? row.value
            : "Ranges" +
            " " +
            (row.value == "0"
              ? "(1.00-1.40)"
              : row.value == "1"
                ? "(1.41-2.80)"
                : "(2.81+)");
      } else {
        return typeID == 1 || typeID == 2 || typeID == 3
          ? `Cashout ${typeID}`
          : "Winner Race (x 2.89)";
      }
    },
  },
});

export default store;
